import classes from '../../css/Contact.module.scss';
import { Helmet } from 'react-helmet';

const Contacto = () => {
    return (
        <div>
			<Helmet>
            <title>Backend Helpers Limited | contacto </title>
            </Helmet>
            <main className={classes['main-content']}>
    	    <section id="contact-us" className={`${classes.container} ${classes['contact-us']}`}>
    		<div  className={classes['contact-left']}>
				<h1 className={classes['contact-title']}>
					PONTE EN <br/>
					<span className={classes['bg-title-contact']}>CONTACTO</span><br/>
				</h1>
            </div>
			<div  className={classes['contact-right']}>
				 <h2>@</h2>
				 <h3>Envíanos un email a
					info@backendhelpers.co </h3>
			</div>
    	    </section>
            </main>
	 </div>
    );
};

export default Contacto;